@if (operation.fichierOperations.length === 0) {
  <div class="flex-vertical padding-8 with-border rounded top-margin-32">
    <div class="flex-horizontal gap-4">
      <div class="flex-1"></div>
      <oui-button
        type="icon"
        color="primary"
        (click)="onMissingFile()"
        [disabled]="isFileUploading || !canSendToPartenaire()"
        ><oui-icon>unknown_document</oui-icon></oui-button
        >
        <oui-button
          type="icon"
          color="primary"
          (click)="onAddFichierOperation()"
          [disabled]="isFileUploading || !canSendToPartenaire()"
          ><oui-icon>add_circle</oui-icon></oui-button
          >
        </div>
        <div class="flex-horizontal gap-16">
          <div class="flex-vertical flex-1 gap-16">
            @if (!isFileUploading) {
              <oui-etat-vide
                [title]="'Aucun document à controler'"
              icon="unknown_document"></oui-etat-vide>
            }
            @if (isFileUploading) {
              <oui-loading class="flex-vertical flex-center padding-vertical-16"></oui-loading>
            }
            <div class="flex-horizontal flex-center justify-center margin-bottom-32">
              <oui-button
                type="contained"
                color="primary"
                (click)="onSendToPartenaire()"
                [disabled]="isFileUploading || !canSendToPartenaire()"
                >Transmettre au partenaire</oui-button
                >
              </div>
            </div>
          </div>
        </div>
      }
